export function Question(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon / Question/ Circle">
          <path
            id="Icon"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM20.5632 28.1246C20.5632 29.4618 21.4224 30.4136 22.926 30.4136C24.4057 30.4136 25.0263 29.6204 25.432 28.3059C25.8377 26.1756 26.5298 25.3824 29.1074 23.4561C32.2816 21.1218 34 19.1955 34 15.9547C34 11.1048 29.8473 8 23.8329 8C20.6826 8 18.2243 8.77054 16.5298 10.153C14.9785 11.4221 14 13.1445 14 14.7082C14 15.8414 14.7399 16.7025 16.0286 16.7025C16.9833 16.7025 17.5084 16.3173 18.1527 15.2748C19.3461 13.0765 21.0406 12.0793 23.5943 12.0793C26.4821 12.0793 28.6062 13.7564 28.6062 16.1133C28.6062 18.1756 27.4606 19.3314 25.0024 21.1898C21.5656 23.796 20.5632 25.2918 20.5632 28.1246ZM19.7518 37.0765C19.7518 38.7535 21.2076 40 22.9737 40C24.7399 40 26.1957 38.7535 26.1957 37.0765C26.1957 35.3994 24.7399 34.1756 22.9737 34.1756C21.2076 34.1756 19.7518 35.3994 19.7518 37.0765Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  );
}
